import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges } from '@angular/core';
import { OrganisationServiceService } from '../../services/organisation-service.service';
import { LoginService } from '../../services/login.service';
import { News, Organisation } from '../../../models/types';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AddNewsComponent } from '../add-news/add-news.component';
import { CommonModule } from '@angular/common';
import { imageLocation } from '../../../environments/environment.development';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faTrash, faPlus, faPen } from '@fortawesome/free-solid-svg-icons';
import { faFacebook } from '@fortawesome/free-brands-svg-icons';
import { NewsDetailsModalComponent } from '../news-details-modal/news-details-modal.component';
import { RouterModule } from '@angular/router';
import Swal from 'sweetalert2';
import {
  trigger,
  transition,
  style,
  animate,
  query,
  stagger
} from '@angular/animations';

@Component({
  selector: 'app-news-list',
  standalone: true,
  imports: [CommonModule, FontAwesomeModule, RouterModule],
  templateUrl: './news-list.component.html',
  styleUrls: ['./news-list.component.scss'],
  animations: [
    trigger('listAnimation', [
      transition('* => *', [
        query(':enter', [
          style({ opacity: 0, transform: 'translateY(20px)' }),
          stagger(100, [
            animate('300ms ease-out', style({ opacity: 1, transform: 'translateY(0)' }))
          ])
        ], { optional: true })
      ])
    ])
  ]
})
export class NewsListComponent {
  @Input() organisation: Organisation | null = null;
  @Input() isSuperAdmin: boolean = false;
  @Input() isOrgAdmin: boolean = false;
  @Input() news: News[] = [];
  @Input() totalNewsCount: number = 0;
  @Output() loadMoreClicked = new EventEmitter<void>();
  @Output() newsChanged = new EventEmitter<News>();

  displayedNews: News[] = []; 

  revealedNewsCount: number = 4; 
  incrementCount: number = 4; 
  initialVisibleCount: number = 4; 
  revealedProductsCount: number = this.initialVisibleCount;
  
  faTrash = faTrash;
  faPlus = faPlus;
  faFacebook = faFacebook;
  faPen = faPen;

  constructor(
    private loginService: LoginService,
    private organisationService: OrganisationServiceService,
    private modalService: NgbModal
  ) {}

  ngOnChanges(changes: SimpleChanges) {
    if (changes['news'] && changes['news'].currentValue) {
      const currentNews = changes['news'].currentValue as News[];
      const previousLength = changes['news'].previousValue?.length || 0;
      const currentLength = currentNews.length;

      // Condition 1: Full refresh, or initial load, or less data than previously shown.
      if (currentLength <= this.revealedNewsCount) {
        // Reset displayedNews to show the currently loaded data (usually the first page)
        this.displayedNews = currentNews;
      } 
      // Condition 2: Load More (parent appended new page data)
      else if (currentLength > previousLength) {
        const newItems = currentNews.slice(previousLength);
        this.displayedNews = [...this.displayedNews, ...newItems];
      } 
      // Condition 3: Catch-all for when the parent has reset the array and sent back the first page
      else {
        this.displayedNews = currentNews.slice(0, this.revealedNewsCount);
      }
      
      // Ensure the visual count matches the items we are now displaying.
      this.revealedNewsCount = this.displayedNews.length;
    }
  }
  
  openNewsModal(news: News) {
    const modalRef = this.modalService.open(NewsDetailsModalComponent, { size: 'lg', backdrop: 'static' });
    modalRef.componentInstance.organisation = this.organisation;
    modalRef.componentInstance.news = news;
    modalRef.componentInstance.isEditMode = false;
    modalRef.result.then((reason) => {
      }
    );
  }
  
  deleteNews(newsID: number) {
    this.organisationService.deleteNews(newsID).subscribe((response) => {
      // Remove the news item from the list
      this.newsChanged.emit();
      Swal.fire({
        icon: 'success',
        title: 'Izbrisano!',
        text: 'Novico ste uspešno izbrisali.',
        timer: 2000,
        timerProgressBar: true,
        showConfirmButton: false
      });
    });
  }

  // Open modal to add news
  openAddNewsModal() {
    const modalRef = this.modalService.open(AddNewsComponent, { size: 'lg', backdrop: 'static' });
    modalRef.componentInstance.organisation = this.organisation;

    modalRef.result.then((result) => {
      if (result === 'newsAdded') {
        this.newsChanged.emit(); // Call your method to refresh news
      }
    }).catch(() => {
    });
  }

  revealMoreNews(): void {
    //this.revealedNewsCount = Math.min(this.news.length, this.revealedNewsCount + this.incrementCount);
    //this.displayedNews = this.news.slice(0, this.revealedNewsCount);
    //this.showLoadMoreButton = this.revealedNewsCount < this.news.length;
    this.loadMoreClicked.emit();
  }

  get showLoadMoreButton(): boolean {
    return this.displayedNews.length < this.totalNewsCount;
  }
  limitedSummary(summary: string): string {
    if (!summary) return '';
    const words = summary.split(/\s+/);
    return words.length > 30 ? words.slice(0, 30).join(' ') + '...' : summary;
  }

  openEditNewsModal(news: News) {
    const modalRef = this.modalService.open(AddNewsComponent, { size: 'lg', backdrop: 'static' });
    modalRef.componentInstance.organisation = this.organisation;
    modalRef.componentInstance.existingNews = news;
    modalRef.componentInstance.isEditMode = true;

    modalRef.result.then((result) => {
      this.newsChanged.emit(); // refresh list
    }).catch(() => {});
  }
}


  

